<template>
  <div
    ref="formRef"
    class="block-contact-form is-wide"
  >
    <FormController
      v-if="data.form && data.form.length === 1"
      :data="data.form[0]"
      :is-loading="isLoading"
      @on-submit="formAction"
    >
      <AtomButton
        button-type="submit"
        :is-disabled="isLoading"
        :text="data.form[0].button_text"
      />
    </FormController>
  </div>
</template>

<script setup>
defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

/*
  Form Handling
*/
const formRef = ref(null);

const {
    isLoading,
    send,
} = useFormAction(formRef);

const strapiClient = useStrapiClient();

const { sendEvent } = useGTM();

const formAction = async (values) => {
    const submitValues = { ...values };
    delete submitValues.statusData;

    sendEvent({
        event: 'contact_form',
        inquiry_type: submitValues.subject,
    });

    await send(async () => {
        await strapiClient('contact-request/send', {
            method: 'POST',
            body: submitValues,
        });
    }, values);
};
</script>

<style lang="scss" scoped>
.block-contact-form {
    @include default-content-columns;

}
</style>
